import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { cn } from "../../lib/utils";

const ModalPostulaciones = ({
  isOpen,
  onClose,
  options,
  selectedOptions,
  setSelectedOptions,
  title,
}) => {
  const [visibleOptions, setVisibleOptions] = useState(10);
  const [tempSelectedOptions, setTempSelectedOptions] = useState(() => [
    ...selectedOptions,
  ]);

  const handleOptionToggle = (option) => {
    const optionValue = option.value; // ✅ Usa el value en vez del label
    if (title === "Seleccionar Fechas") {
      setTempSelectedOptions([optionValue]);
    } else {
      if (tempSelectedOptions.includes(optionValue)) {
        setTempSelectedOptions(
          tempSelectedOptions.filter((item) => item !== optionValue)
        );
      } else {
        setTempSelectedOptions([...tempSelectedOptions, optionValue]);
      }
    }
  };

  const handleApplyFilters = () => {
    setSelectedOptions([...tempSelectedOptions]);
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        <div className="grid max-h-96 grid-cols-2 gap-2 overflow-y-auto sm:grid-cols-3">
          {options.slice(0, visibleOptions).map((option) => (
            <button
              key={option.label}
              type="button"
              onClick={() => handleOptionToggle(option)}
              className={cn(
                "flex flex-col items-center gap-1 rounded-md border border-border p-3 text-center text-sm hover:bg-muted",
                tempSelectedOptions.includes(option.value) &&
                  "border-primary bg-primary/10 text-primary"
              )}
            >
              {option.icon && <span className="text-xl">{option.icon}</span>}
              <span>{option.label}</span>
            </button>
          ))}

          {visibleOptions < options.length && (
            <button
              type="button"
              onClick={() => setVisibleOptions((prev) => prev + 10)}
              className="col-span-2 rounded-md border border-dashed border-border p-3 text-sm text-muted-foreground hover:bg-muted sm:col-span-3"
            >
              Ver más
            </button>
          )}
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => setTempSelectedOptions([])}>
            Limpiar Filtros
          </Button>
          <Button onClick={handleApplyFilters}>Aplicar Filtros</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ModalPostulaciones;
